module.exports = __webpack_public_path__ + "static/Background-voter-4.b8d39163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-voter-4.jpg
// module id = 481
// module chunks = 265584890008614